package com.islamicmedia.shared.domain.model

/**
 * A single media item identified in a user's photo by the image-title extractor.
 * When a photo yields exactly one candidate we search it directly; when it yields
 * several (a shelf of books, a room with a TV and a poster) we show a chooser.
 */
data class MediaCandidate(
    val title: String,
    val mediaType: MediaType? = null
)
